var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 7C0.5 3.39698 3.39698 0.5 7 0.5C10.603 0.5 13.5 3.39698 13.5 7C13.5 10.603 10.603 13.5 7 13.5C3.39698 13.5 0.5 10.603 0.5 7Z",
    stroke: "#00A3E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.46246 7.7875C4.34579 7.67083 4.34579 7.49583 4.46246 7.37917C4.57913 7.2625 4.75413 7.2625 4.87079 7.37917L6.70829 9.21667V2.91667C6.70829 2.74167 6.82496 2.625 6.99996 2.625C7.17496 2.625 7.29163 2.74167 7.29163 2.91667V9.21667L9.12913 7.37917C9.24579 7.2625 9.42079 7.2625 9.53746 7.37917C9.65413 7.49583 9.65413 7.67083 9.53746 7.7875L7.20413 10.1208C7.17496 10.15 7.14579 10.1792 7.11663 10.1792C7.08746 10.2083 7.02913 10.2083 6.99996 10.2083C6.97079 10.2083 6.91246 10.2083 6.88329 10.1792C6.85413 10.15 6.82496 10.15 6.79579 10.1208L4.46246 7.7875ZM9.91663 9.625C9.74163 9.625 9.62496 9.74167 9.62496 9.91667V10.7917H4.37496V9.91667C4.37496 9.74167 4.25829 9.625 4.08329 9.625C3.90829 9.625 3.79163 9.74167 3.79163 9.91667V11.0833C3.79163 11.2583 3.90829 11.375 4.08329 11.375H9.91663C10.0916 11.375 10.2083 11.2583 10.2083 11.0833V9.91667C10.2083 9.74167 10.0916 9.625 9.91663 9.625Z",
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.086a2efcea511d8e6ff092d8cf56a2c7.svg";
export { ForwardRef as ReactComponent };